// extracted by mini-css-extract-plugin
export var chip = "_bs-0";
export var filterDropdown = "_bs-5";
export var filterItem = "_bs-6";
export var icon = "_bs-1";
export var removeButton = "_bs-3";
export var removeIcon = "_bs-4";
export var separator = "_bs-2";